import Vue from 'vue'
import JsonApiObject from '@/_models/JsonApi'
import LanguageModel from './language'
import StringGroupModel from './stringGroup'

import TranslationJobInput from '@/views/Language/dialogs/translationJobInput/translationJobInput.vue'
import ConfirmDelete from '@/views/Language/dialogs/confirmDelete/confirmDelete.vue'

export default class TranslationJobModel extends JsonApiObject {
    static async initPost(
        translationJob: null,
        translationJobs: Array<TranslationJobModel>,
        stringGroups: Array<StringGroupModel>
    ) {
        return await JsonApiObject.openDialog(TranslationJobInput, {
            translationJob,
            translationJobs,
            stringGroups,
        })
    }

    static async post(data: any) {
        let query = {
            include: ['languages', 'groups'],
            body: { data: data },
        }

        let res = await Vue.prototype.$vbit.post('language', `translationJobs`, query)

        return res.data ? new TranslationJobModel(res.data, res.included) : res
    }

    static async get(stringTokenId: string) {
        let query = {
            include: ['languages', 'groups'],
        }

        let res = await Vue.prototype.$vbit.get(
            'language',
            `translationJobs/${stringTokenId}`,
            query
        )

        return res.data ? new TranslationJobModel(res.data, res.included) : res
    }

    static async getAllTranslationJobs(token: string | null = null) {
        let query = {
            include: ['languages', 'groups'],
            ...(token && {
                token,
            }),
        }

        let res = await Vue.prototype.$vbit.get('language', `translationJobs`, query)

        return res && res.data
            ? res.data.map(
                  (translationJob) => new TranslationJobModel(translationJob, res.included)
              )
            : res
    }

    public constructor(data: any, included?) {
        super(data, included)
    }

    name
    token
    expiresAt
    deleted
    createdAt
    updatedAt

    get languages(): Array<LanguageModel> {
        return this._relationships['languages'] ? this._relationships['languages'] : []
    }

    set languages(languages: Array<LanguageModel>) {
        this._relationships['languages'] = languages
    }

    get groups(): Array<StringGroupModel> {
        return this._relationships['groups'] ? this._relationships['groups'] : []
    }

    set groups(groups: Array<StringGroupModel>) {
        this._relationships['groups'] = groups
    }

    get link() {
        return this.token
            ? `https://${
                  process.env.VUE_APP_VBIT_API == 'devapi.vbit.com'
                      ? 'alpha.vbit.com/'
                      : 'app.vbit.com/'
              }/language-module/${this.token}`
            : null
    }

    async initiatePatch(
        translationJob: TranslationJobModel,
        translationJobs: Array<TranslationJobModel>,
        stringGroups: Array<StringGroupModel>
    ) {
        return await JsonApiObject.openDialog(TranslationJobInput, {
            translationJob,
            translationJobs,
            stringGroups,
        })
    }

    async patch(data: any) {
        let query = {
            updatedAt: this['updatedAt'],
            include: ['languages', 'groups'],
            body: { data: data },
        }

        let res = await Vue.prototype.$vbit.patch('language', `translationJobs/${this._id}`, query)

        return res.data ? this.initalize(res.data, res.included) : res
    }

    async delete() {
        let res = await JsonApiObject.openDialog(ConfirmDelete, {
            name: this.name,
            deleted: this.deleted,
            type: 'translationJob',
            needConfirm: false,
        })
        if (res) {
            let data = {
                id: this._id,
                type: this._type,
                attributes: {
                    deleted: !this.deleted,
                },
            }

            return await this.patch(data)
        }
    }
}
